'use strict';

var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;
function verification(isValid, isPotentiallyValid) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid
  };
}
function postalCode(value, options) {
  var minLength;
  options = options || {};
  minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;
  if (typeof value !== 'string') {
    return verification(false, false);
  } else if (value.length < minLength) {
    return verification(false, true);
  }
  return verification(true, true);
}
module.exports = postalCode;